export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":""}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"https://images.squarespace-cdn.com/content/v1/659db5cc2685675d61a87e77/00970d54-e8f1-423e-81b5-793dc1540dc4/favicon.ico?format=200w"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://images.squarespace-cdn.com/content/v1/659db5cc2685675d61a87e77/00970d54-e8f1-423e-81b5-793dc1540dc4/favicon.ico?format=100w"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://images.squarespace-cdn.com/content/v1/659db5cc2685675d61a87e77/00970d54-e8f1-423e-81b5-793dc1540dc4/favicon.ico?format=100w"},{"rel":"stylesheet","type":"text/css","href":"https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700"}],"style":[],"script":[{"src":"/scripts/core.min.js","tagPosition":"bodyClose"}],"noscript":[],"title":"Hansen Rent"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false,"value":null,"errorValue":null}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true